import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PaginatedResponse } from '../../../shared/interfaces/pagination';
import { environment } from '../../../../environments/environment';
import { Notifications } from '../models/notifications';
import { NotificationStatus } from '../models/notification-status';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private apiUrl = environment.apiBaseUrl;
  private functionAppUrl = environment.auditLogApiUrl;
  private http: HttpClient = inject(HttpClient);
  private hasUnreadNotification = new Subject<number[]>();

  hasUnreadNotificationExists$ = this.hasUnreadNotification.asObservable();

  getAllNotifications(
    page = 1,
    pageSize = 10,
  ): Observable<PaginatedResponse<Notifications>> {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());
    return this.http.get<PaginatedResponse<Notifications>>(
      `${this.apiUrl}/api/notifications/`,
      {
        params,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  deleteNotification(ids: number[]): Observable<unknown> {
    const body = { notification_ids: ids };
    return this.http.delete<unknown>(
      `${this.apiUrl}/api/notifications/delete`,
      {
        body,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  updateNotificationReadStatus(
    ids: number[],
    isRead: boolean,
  ): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.apiUrl}/api/notifications/read/${isRead}`,
      {
        ids: ids,
      },
    );
  }

  IsUnreadNotificationsExist(): Observable<NotificationStatus> {
    return this.http.get<NotificationStatus>(
      `${this.functionAppUrl}/api/user/status`,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
}
